import getCashierStoreInformationCardSettings from './getCashierStoreInformationCardSettings';
import getCashierStoreLocationCardSettings from './getCashierStoreLocationCardSettings';
export default {
  getCashierStoreInformationCardSettings,
  getCashierStoreLocationCardSettings,
};
